//@service
import {bind,RepositoryInterface} from '@/service/utils'
export const taskService= {
  get taskShowRepository() {
    return bind(() => import('./taskShow.repo'), RepositoryInterface);
  },
  get taskAdminRepository() {
    return bind(() => import('./taskAdmin.repo'), RepositoryInterface);
  },
  get personContentRepository() {
    return bind(() => import('./personContent.repo'), RepositoryInterface);
  },
  get paymentRepository() {
    return bind(() => import('./payment.repo'), RepositoryInterface);
  },
  get taskRepository() {
    return bind(() => import('./task.repo'), RepositoryInterface);
  },
}

